// import { useToast } from '../../../hooks/ToastContext';
// import { Dialog, Switch, Transition } from '@headlessui/react';
// import { CheckCircleIcon, InformationCircleIcon, XCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';
// import axios from 'axios';
// import React, { Fragment, useEffect, useRef, useState } from 'react';

import LockIcon from "../../../Icons/LockIcon";
import RewardIcon from "../../../Icons/RewardIcon";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import ShowRewards from "../../../Components/FeComponents/Popups/ShowRewards";
import InstructionIcon from "../../../Icons/InstructionIcon";
import ExternalRewardIcon from "../../../Icons/ExternalRewardIcon";
import HostedRewardIcon from "../../../Icons/HostedRewardIcon";
import AudioRewardIcon from "../../../Icons/AudioRewardIcon";
import VideoRewardIcon from "../../../Icons/VideoRewardIcon";
import config from "../../../config";
import axios from "axios";
import { useLoader } from "../../../hooks/LoaderContext";

function Rewards({ isOpen = false, onClose, title, contest_id, lang }) {
  // const { showToast } = useToast();
  const cancelButtonRef = useRef(null);
  const [prizesetup, setprizesetup] = useState({});
  const [ribbontext, setribbontext] = useState(null);
  const [displayreward, setdisplayreward] = useState(0);
  const [activerewards, setactiverewards] = useState({});
  const { showLoader, hideLoader } = useLoader();
const hasFetchedData = useRef(false);

  // useEffect(() => {
  //     //sessionStorage.removeItem('member_'+id);
  //     //console.log(memberbadges);

  // }, [prizesetup]);

  const gotoRewardsPage = (val, prize) => {
    setdisplayreward(val);
    setactiverewards(prize);
  };
  const handleDownload = (prize) => {
    if (prize.reward_file) {
      let fileName = prize.reward_file;
      //const fileExtension = prize.reward_file.split('.').pop().split(/\#|\?/)[0];
      const fileExtension = prize.reward_file.split(".").pop().split(/#|\?/)[0];
      // Ensure the fileName has the correct extension
      if (!fileName.endsWith(`.${fileExtension}`)) {
        fileName = fileName + `.${fileExtension}`;
      }

      // Create a download link
      const link = document.createElement("a");
      link.href = prize.reward_file; // Use the reward_file URL here
      link.download = fileName; // Set the download filename
      link.click();
    }
  };

  const gotoExternalUl = (prize) => {
    if (prize.reward_file) {
      window.open(prize.reward_file, "_blank");
    }
  };

  const fePrizeSetupdetail = useCallback(async () => {
    showLoader();
    setdisplayreward(0);
    const session_member = sessionStorage.getItem("member_" + contest_id);
    if (session_member) {
      const memberDet = JSON.parse(session_member);
      try {
        let payload = {
          contest_id: contest_id,
          contest_member_id: memberDet.contest_member_id,
          type: "reward",
        };
        const res = await axios.post(
          `${config.API_URL}/get-prize-setup`,
          payload
        );
        if (res.status === 200) {
          console.log(res.data.prize);
          setprizesetup(res.data.prize);
          if (res.data.ribbon_text) {
            setribbontext(res.data.ribbon_text);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        hideLoader();
      }
    }
  }, [contest_id,showLoader,hideLoader]);

  useEffect(() => {
   if (isOpen && !hasFetchedData.current) {
     fePrizeSetupdetail();
     hasFetchedData.current = true;
   }
 
   // Reset flag on close
   if (!isOpen) {
     hasFetchedData.current = false;
   }
  }, [isOpen, fePrizeSetupdetail]);

  function trimdescription(description) {
    const maxLength = 210;
    const trimmedDescription =
      description.length > maxLength
        ? description.substring(0, maxLength) + "..."
        : description;
    return trimmedDescription;
  }

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-full max-w-[724px] h-auto max-h-[90vh] sm:max-h-[801px]">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="flex items-center justify-between border-b pb-3 px-4">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-bold text-gray-900 flex items-center gap-3"
                  >
                    <img
                      src="https://img.flexifunnels.com/flexicontest/reward_ribbon.png"
                      alt=""
                      className="w-14 h-14"
                    />
                    <div>
                      <h2>{title}</h2>
                      {ribbontext && (
                        <p className="text-sm font-normal text-gray-500">
                          {ribbontext}
                        </p>
                      )}
                    </div>
                  </Dialog.Title>
                  <button
                    type="button"
                    className="absolute right-3 top-3 rounded-md bg-[#E5E5E5A3]  p-1 text-gray-500"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon
                      className="h-5 w-5 text-black"
                      aria-hidden="true"
                    />
                  </button>
                </div>

                {/* Scrollable Content */}
                <div className="p-4 flex flex-col items-center gap-4 overflow-y-auto max-h-[70vh] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                  {Array.isArray(prizesetup) &&
                  prizesetup.length > 0 &&
                  displayreward === 0 ? (
                    prizesetup.map((prize, index) => (
                      <div
                        key={prize.id}
                        className={`primary_border_color relative flex flex-col sm:flex-row items-center border rounded-lg shadow-lg w-full bg-white h-auto sm:h-[203px] ${
                          !prize.status ? "opacity-100" : "border-[#5CA8FF]"
                        }`}
                      >
                        <div className="relative w-full sm:w-[217px]">
                          {prize.reward_image ? (
                            <img
                              src={prize.reward_image}
                              alt={prize.reward_name}
                              className="w-full sm:w-[217px] h-[201px]  object-cover rounded-s-md sm:rounded-s-md"
                            />
                          ) : (
                            <div className="w-full sm:w-[217px] h-[201px]  flex justify-center items-center border border-r border-[#F3F3F3] rounded-md">
                              <img
                                src={
                                  prize.reward_type === 1
                                    ? "https://img.flexifunnels.com/flexicontest/instruction.svg"
                                    : prize.reward_type === 2
                                    ? "https://img.flexifunnels.com/flexicontest/external.svg"
                                    : prize.reward_type === 3
                                    ? "https://img.flexifunnels.com/flexicontest/video.svg"
                                    : prize.reward_type === 4
                                    ? "https://img.flexifunnels.com/flexicontest/audio.svg"
                                    : prize.reward_type === 5
                                    ? "https://img.flexifunnels.com/flexicontest/hosted.svg"
                                    : ""
                                }
                                alt={prize.reward_name}
                                className=" object-cover rounded-s-md sm:rounded-s-md"
                              />
                            </div>
                          )}
                          <div className="absolute left-0 top-0">
                            <div className="primary_bg bg-[#093A73] rounded-br-md rounded-tl-md text-base text-white font-bold px-4 py-1 flex gap-1 items-center">
                              <span className="text-[12px] flex items-center leading-[22px] text-left tracking-[0px] text-white opacity-100 font-normal">
                                <span className="mr-1">
                                  <RewardIcon width={"10"} />
                                </span>{" "}
                                {prize.points} {lang?.points || "Points"}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="p-4 px-6 flex flex-col flex-1">
                          <h2 className="text-[14px] leading-[17px] font-semibold text-black opacity-90 text-left">
                            {prize.reward_name}
                          </h2>
                          <p
                            className="text-[11px] md:h-[50px] leading-[15px] py-1 text-left text-[#767676] opacity-100 md:line-clamp-3 "
                            title={trimdescription(prize?.reward_description)}
                          >
                            {trimdescription(prize?.reward_description)}
                          </p>

                          <div className="grid grid-cols-2 sm:flex bg-[#F5F3F3] items-center gap-4 mt-2 p-3 rounded-md text-gray-700 text-sm">
                            <div className="flex flex-col">
                              <span className="primary_text_color text-[11px] text-left text-[#0274F7] font-normal">
                                {lang?.total_value || "Total Value"}
                              </span>
                              <span className="text-[15px] text-left text-black font-bold mt-1">
                                 {prize?.symbol || "₹"}{prize.reward_value}
                              </span>
                            </div>
                            {/* <div className="flex flex-col border-l sm:border-l  pl-5 sm:pl-5 sm:pt-0 pt-2">
                                                            <span className="text-[11px] text-left text-[#0274F7] font-normal">
                                                                Badge
                                                            </span>
                                                            <span className="text-[15px] text-left text-black font-bold mt-1">
                                                                <BadgeLogoIcon className={"w-6 h-5"} />
                                                            </span>
                                                        </div> */}
                            <div className="col-span-2 sm:col-auto flex flex-col border-t border-[#D9D9D9] pt-2 sm:pt-0 sm:border-t-0 sm:border-l pl-0 sm:pl-5">
                              <span className="primary_text_color text-[11px] text-left text-[#0274F7] font-normal">
                                {/* {prize.member_reward_count} players unlocked this reward */}

                                {lang?.players_unlocked_this_reward
                                  ? lang.players_unlocked_this_reward.replace(
                                      "[reward_count]",
                                      prize?.member_reward_count ?? 0
                                    )
                                  : `${
                                      prize?.member_reward_count ?? 0
                                    } players unlocked this reward`}
                              </span>
                              {/* <span className="text-[15px] text-left text-black font-bold mt-1">
                                                                1
                                                            </span> */}
                            </div>
                          </div>
                          {prize.status === 1 && (
                            <div className="w-full">
                              {prize.reward_type === 1 && (
                                <button
                                  onClick={() => gotoRewardsPage(1, prize)}
                                  className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                >
                                  <span>
                                    <InstructionIcon width={14} height={13} />
                                  </span>
                                  {lang?.click_here || "Click here"}
                                </button>
                              )}
                              {prize.reward_type === 2 && (
                                <button
                                  onClick={() => gotoExternalUl(prize)}
                                  className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                >
                                  <span>
                                    <ExternalRewardIcon
                                      width={14}
                                      height={13}
                                    />
                                  </span>
                                  {lang?.click_here || "Click here"}
                                </button>
                              )}
                              {prize.reward_type === 3 && (
                                <button
                                  onClick={() => gotoRewardsPage(1, prize)}
                                  className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                >
                                  <span>
                                    <VideoRewardIcon width={14} height={13} />
                                  </span>
                                  {lang?.watch_video || "Watch Video"}
                                </button>
                              )}

                              {prize.reward_type === 4 && (
                                <button
                                  onClick={() => gotoRewardsPage(1, prize)}
                                  className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                >
                                  <span className="">
                                    <AudioRewardIcon width={14} height={13} />
                                  </span>{" "}
                                  {lang?.listen_music || "Listen Music"}
                                </button>
                              )}

                              {prize.reward_type === 5 && (
                                <button
                                  onClick={() => handleDownload(prize)}
                                  className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                >
                                  <span>
                                    <HostedRewardIcon width={14} height={13} />
                                  </span>
                                  {lang?.download || "Download"}
                                </button>
                              )}
                            </div>
                          )}

                          {prize.status === 0 && (
                            <div className="absolute group inset-0 flex flex-col items-center justify-center rounded-md border border-[#CFCFCF] hover:bg-white bg-opacity-100">
                              <span className="primary_light_bgcolor3 primary_border_color mb-2 text-gray-500 bg-[#DFECFC] border border-[#A6C9F1] p-4 rounded-full hidden group-hover:block">
                                <LockIcon className={"w-6 h-6"} />
                              </span>
                              <p className="text-[12px] top-full leading-[15px] text-center text-[#202E3A] opacity-100 font-medium px-10 sm:px-60 hidden group-hover:block">
                                {prize.reward_msg}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : displayreward === 0 ? (
                    <p>
                      {lang?.no_rewards_available || "No Rewards available"}
                    </p>
                  ) : (
                    <div></div>
                  )}

                  {displayreward === 1 && (
                    <ShowRewards
                      setdisplayreward={setdisplayreward}
                      activerewards={activerewards}
                    />
                  )}
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default Rewards;
